import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

const Title = styled.h3`
  max-height: 95px;
  margin: 0 0 auto;
  padding: 0 16px;
  color: #fff;
  ${TYPOGRAPHY.title}
  line-height: 1.33;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; /* используется для многострочного эллипсиса */
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;

export default Title;
